<template>
  <div v-if="!edit && alert.status === 'success'">
    <Alert class="mt-2" status="success">
      {{ alert.message }}
    </Alert>

    <router-link v-if="showLogin" class="btn btn-primary" :to="{ name: 'login' }">Login</router-link>
  </div>
  <FormContainer v-else @submitForm="signup">
    <Alert v-if="edit && alert.status" class="mt-2" :status="alert.status">
      {{ alert.message }}
    </Alert>

    <div class="container-fluid" v-if="alert.status !== 'success' || edit">
      <div class="row">
        <FormInputTextWidget
          class="col-12 col-md-6"
          label="Nome"
          v-model="user.name"
          :errorMsg="errorHash.name"
          @input="removeError('name')"
        />
        <FormInputTextWidget
          class="col-12 col-md-6"
          label="Cognome"
          v-model="user.surname"
          :errorMsg="errorHash.surname"
          @input="removeError('surname')"
        />
      </div>

      <div class="row">
        <FormInputTextWidget
          v-if="!edit"
          class="col-12"
          label="Email"
          placeholder="example@email.com"
          v-model="user.email"
          :errorMsg="errorHash.email"
          type="email"
          @input="removeError('email')"
        />
        <FormInputTextWidget
          v-else
          class="col-12"
          label="Email"
          disabled
          :value="user.email"
          type="email"
        />
      </div>

      <div class="row">
        <FormInputTextWidget
          v-if="!edit"
          class="col-12 col-md-6"
          label="Password"
          v-model="user.password"
          :errorMsg="errorHash.password"
          type="password"
          @input="removeError('password')"
        />

        <FormInputTextWidget
          v-if="!edit"
          class="col-12 col-md-6"
          label="Conferma Password"
          v-model="confirmPassword"
          :errorMsg="errorHash.confirmPassword"
          type="password"
          @input="removeError('confirmPassword')"
        />
      </div>
    </div>

    <div class="pt-5 text-right">
      <button class="btn btn-primary" type="submit">
        {{edit ? 'Aggiorna': 'Registrati'}}
      </button>
    </div>
  </FormContainer>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate';
import uploadFilesMixin from '@/libs/Uploader/mixins/uploadFiles';

export default {
  name: 'profile-signup-or-edit',
  mixins: [validateMixin, uploadFilesMixin],
  components: {
    FormContainer: () => import('@/libs/Form/components/FormContainer'),
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    Alert: () => import('@/libs/Feedback/components/Alert'),
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => ({
        name: null,
        surname: null,
        email: null,
        password: null,
      }),
    },
  },
  data () {
    return {
      alert: {
        status: null,
        message: null,
      },
      showLogin: false,
      fixedMaxFiles: 1,
      privacy: false,
      confirmPassword: null,
    };
  },
  methods: {
    signup () {
      if (!this.isValid()) {
        return;
      }

      if (!this.uploadsFinishedAndReadyToSubmit()) {
        this.addError('avatar', 'Sto ancora caricando!');

        return;
      }

      const userToSend = { ...this.user };
      const request = this.edit ? this.$api.updateMyProfile : this.$api.registerUser;

      const successHandler = this.edit ? res => {
        this.alert.status = 'success';
        this.alert.message = 'Dati del profilo aggiornati con successo';
        this.$oauth2.getMe(true);
        this.$emit('update', res);
      } : res => {
        this.alert.status = 'success';
        this.alert.message = 'Registrazione avvenuta con successo, procedi alla pagina di Login';
        this.showLogin = true;
        this.$emit('update', res);
      };

      request(userToSend)
        .then(successHandler)
        .catch(err => {
          this.$emit('error', err);

          if (err.response.status === 406 && err.response.data.type === 'address') {
            this.addressSuggestions = err.response.data.address_suggest;
            this.addError('Errore', 'address');
          }
          if (err.response.data.msg) {
            this.alert.status = 'danger';
            this.alert.message = err.response.data.msg;
          }
        })
      ;
    },
    isValid () {
      this.clearErrors();

      // name
      if (!this.user.name) {
        this.addError('Inserisci il nome', 'name');
      }
      // surname
      if (!this.user.surname) {
        this.addError('Inserisci il cognome', 'surname');
      }

      if (this.edit) {
        return !this.hasErrors;
      }

      // email
      if (!this.validateEmail(this.user.email)) {
        this.addError('L\'email che hai inserito non è valida', 'email');
      }

      // Password
      // ConfirmPassword
      if (!this.user.password) {
        this.addError('Inserisci la password', 'password');
      } else if (this.user.password.length < 8 || !this.user.password.match(/\d|[^\w\s]/)) {
        this.addError('La password deve avere almeno 8 caratteri, compreso un numero o un simbolo.', 'password');
      } else if (!this.confirmPassword) {
        this.addError('Inserisci la password di conferma', 'confirmPassword');
      } else if (this.user.password !== this.confirmPassword) {
        this.addError('La password e la password di conferma devono essere uguali', 'confirmPassword');
      }

      return !this.hasErrors;
    },
    validateEmail (email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    resetFeedBack () {
      this.alert.status = null;
      this.alert.message = null;
    },
  },
  mounted () {},
};

</script>

<style lang="scss"></style>
